export default "/images/x-circle.svg?bd4906d4f5c28e4d73214d1258d63a2e";